import styled from 'styled-components';

import { reduceOpacity } from '../../../utils/colors';
import { COLORS } from '../../../utils/theme/colors';

export const Container = styled.div`
  padding: 16px 32px;
  background-color: ${COLORS.white};
  width: 280px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;

  @media (max-width: 1047px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  margin-left: 16px;
`;

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => reduceOpacity(theme.primary, 0.94)};
  display: flex;
  justify-content: center;
  border-radius: 8px;
  align-items: center;
`;

export const Label = styled.h5`
  color: #a0a4ad;
`;

export const Value = styled.h2``;
